import React, { useMemo } from "react";

import SimpleSelect from "app/Components/SearchableSelect/SimpleSelect";
import InputError from "app/Components/_form/InputError/InputError";
import { Col, Row, FormGroup } from "react-bootstrap";
import { employeeFormLabel } from "../Constant";
import Label from "app/Components/_form/Label/Label";
import DatePicker from "app/Components/DateTimeCustom/CustomDateTime";
import { siteTypeList } from "app/_pages/_globalConfiguration/HealthSafetyEnvironment/Sites/Sites";
import { disableFutureDate } from "app/_helpers/dateHelper";
import { contractorPersonFormLabel } from "../../ContractorPerson/Constant";
import InitialTrainingForm from "./InitialTrainingForm";
import InitialMedicalForm from "./InitialMedicalForm";

function InitialLocationForm({
  form = {},
  onChange,
  error = {},
  siteList = [],
  contractorList = [],
  showContractor = false,
  menuPortalTarget,
  showTraining,
  showMedical,
  hideMedicalForm,
  lgClass,
  isDisable,
  locationTitle,
}) {
  return (
    <div className="mt-2">
      <h5>{locationTitle || "Location"}</h5>
      <Row>
        {showContractor && (
          <Col md={4}>
            <FormGroup>
              <Label>{contractorPersonFormLabel["contractorId"]}</Label>

              <SimpleSelect
                name={"contractorId"}
                value={+form?.contractorId}
                onChange={onChange}
                options={contractorList.map((d) => ({
                  name: `${d.contractorLegalEntity}`,
                  value: d.id,
                }))}
                label={"name"}
                id="value"
                placeHolder={contractorPersonFormLabel["contractorId"]}
                error={error["contractorId"]}
                disabled={!form.employmentStatus || form.employmentStatus === "inActive"}
                menuPortalTarget={menuPortalTarget}
              />
              <InputError error={error["contractorId"]} />
            </FormGroup>
          </Col>
        )}
        <Col md={4}>
          <FormGroup>
            <Label>{employeeFormLabel["siteType"]}</Label>

            <SimpleSelect
              name={"siteType"}
              value={form?.siteType}
              onChange={onChange}
              options={siteTypeList}
              label={"name"}
              id="value"
              placeHolder={employeeFormLabel["siteType"]}
              error={error["siteType"]}
              menuPortalTarget={menuPortalTarget}
            />
            <InputError error={error["siteType"]} />
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label>{employeeFormLabel["currentWorkLocation"]}</Label>

            <SimpleSelect
              name={"currentWorkLocation"}
              value={form?.currentWorkLocation}
              onChange={onChange}
              options={
                form?.siteType
                  ? siteList
                      .filter((d) => d.siteType === +form?.siteType)
                      .map((d) => ({
                        name: `${d.name}`,
                        value: d.id,
                      }))
                  : []
              }
              label={"name"}
              disabled={!form?.siteType}
              id="value"
              placeHolder={employeeFormLabel["currentWorkLocation"]}
              error={error["currentWorkLocation"]}
              menuPortalTarget={menuPortalTarget}
            />
            <InputError error={error["currentWorkLocation"]} />
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label>{employeeFormLabel["startDateAtMines"]}</Label>

            <DatePicker
              name={"startDateAtMines"}
              value={form?.startDateAtMines}
              onChangeDate={onChange}
              label={employeeFormLabel["startDateAtMines"]}
              placeHolder={employeeFormLabel["startDateAtMines"]}
              error={error["startDateAtMines"]}
              disabled={!form?.siteType}
              isValidDate={disableFutureDate}
            />
            <InputError error={error["startDateAtMines"]} />
          </FormGroup>
        </Col>

        <Col md={2}>
          <FormGroup>
            <Label>{employeeFormLabel["mineTag"]}</Label>

            <span>{form?.mineTag === "yes" ? "YES" : "NO"}</span>
            <InputError error={error["mineTag"]} />
          </FormGroup>
        </Col>
      </Row>

      {!form?.lastIMEDate && !form?.lastPMEDate && (
        <>
          {showTraining && (
            <InitialTrainingForm
              menuPortalTarget={menuPortalTarget}
              form={form}
              onChange={onChange}
              error={error}
              isDisable={isDisable}
            />
          )}

          {form?.siteType === 3 && !hideMedicalForm && (
            <InitialMedicalForm
              menuPortalTarget={menuPortalTarget}
              lgClass={lgClass ? lgClass : 6}
              form={form}
              onChange={onChange}
              error={error}
              showMedical={showMedical}
              isDisable={isDisable}
            />
          )}
        </>
      )}
    </div>
  );
}

export default InitialLocationForm;
